import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, concat, forEach } from 'lodash';
import {
    getLeaguesData,
    getPublicLeaguesData
} from './../../actions/LeagueActions';
import LeagueHomePageCard from './LeagueHomePageCard';
import OutsideNotifier from '../../OutsideNotifier';
import JoinLeague from './JoinLeague';
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import LeagueShare from './league-share';
import GeneralPopUp from './../GeneralPopUp';
import AdBottom from '../AdBottom';
import CreateLeaguePopup from './create-league-popup';
import { fetchClubs } from '../../actions/FormationActions';
import LeagueInvite from './leagueInvite';
import LeaguesErrorPopup from './LeaguesErrorPopup';
import trackEventsObj from './../../constants/new-pageTrackEvents'
class Leagues extends Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.onCloseCreateLeague = this.onCloseCreateLeague.bind(this);
        this.onDecline = this.onDecline.bind(this);
        this.onInviteJoinError = this.onInviteJoinError.bind(this);
        this.onSubmitErrorPopup = this.onSubmitErrorPopup.bind(this);


        this.state = {
            message: '',
            popupWrapperClass: '',
            iconClass: '',
            showPopup: false,
            joinLeaguePopup: false,
            isMoreOpen: false,
            readAbleShareLoad: {},
            showShare: false,
            tooltipActive: false,
            showCreateLeague: false,
            showInvitePopup: false,
            inviteJoinError: ""
        };
        this.page = 1;
    }

    componentWillMount() {
        let { leagueCode, leagueName, userName } = this.props.match.params;

        if (leagueName) {
            leagueName = common.CompConvertHexToString(leagueName).v1
        }
        if (!leagueCode) {
            let leagueInvObj = common.getLocalStorage('leagueInvObj');
            if (leagueInvObj) {
                leagueCode = leagueInvObj.leagueCode
                leagueName = leagueInvObj.leagueName
                userName = leagueInvObj.userName
            }
        }

        const GUID = common.getDataFromCookie('GUID');
        const hasTeam = common.isManageTeam();
        if (leagueCode) {
            if (!GUID || !hasTeam) {
                common.setLocalStorage('leagueInvObj', { leagueCode, leagueName, userName });
                return this.props.history.replace('/create-team');
            } else {
                common.virPathTracking('leagueJoin');
                this.setState({ readAbleShareLoad: { leagueCode, leagueName, userName }, showInvitePopup: true });
            }
        } else {
            if (!GUID || !hasTeam) {
                return this.props.history.replace('/create-team');
            }
        }
    }

    componentDidMount() {
        this.getLeagues();
        this.getPublicLeagues();
        if (Boolean(sessionStorage.getItem('leagueDeleted')) === true) {
            const message = sessionStorage.getItem('display_message');
            sessionStorage.removeItem('display_message');
            sessionStorage.removeItem('leagueDeleted');
            this.handleToast({
                message: message,
                leagueCreated: true,
                isToast: true,
                popupWrapperClass: 'si-warning-toast si-success-popup',
                iconClass: 'icon-ucl-tick',
                showPopup: true
            });
        }
    }

    componentWillUnmount() {
        this.setState({
            isMoreOpen: false,
        });
    }

    toggleMoreIcon = () => {
        this.setState(prevState => ({
            isMoreOpen: !prevState.isMoreOpen,
        }));
    };
    onRulesTap = () => {
        common.pageViewTracking(config.RULES_URL, trackEventsObj["rules"]);
        return window.open(config.RULES_URL);
    };
    onHelpTap = () => {
        common.pageViewTracking(config.HELP_URL, trackEventsObj["help"]);
        return window.open(config.HELP_URL);
    };
    getLeagues = () => {
        const GUID = common.getGUID();
        const hasTeam = common.isManageTeam();
        if (GUID && hasTeam) {
            this.props.getLeaguesData(GUID, this.page).then(() => {
                const response = this.props.leagues;
                if (response && (response.current.length == 0 && response.previous.length == 0)) {
                    //track empty league
                    common.pageViewTracking("", trackEventsObj["emptyLeague"]);
                }
                const errorKeyFromTrans = apiError.leagues;
                const message = this.props.trans[errorKeyFromTrans];
                if (!response) {
                    let stateToSet = {
                        message,
                        isToast: true,
                        popupWrapperClass: 'si-warning-toast si-error-popup',
                        iconClass: 'icon-ucl-warning-icon',
                        showPopup: true
                    };
                    this.handleToast(stateToSet);
                }
            });
        }
    };
    getPublicLeagues = () => {
        const GUID = common.getGUID();
        const hasTeam = common.isManageTeam();
        if (GUID && hasTeam) {
            const CountryId = common.getDataFromCookie('CountryId');
            const FavTeamId = common.getDataFromCookie('FavSoccerTeamId');
            this.props.getPublicLeaguesData(GUID, CountryId, FavTeamId, config.CURRENT_LANGUAGE).then(() => {
                const response = this.props.publicLeagues;
                const errorKeyFromTrans = apiError.leagues;
                const message = this.props.trans[errorKeyFromTrans];
                if (!response) {
                    let stateToSet = {
                        message,
                        isToast: true,
                        popupWrapperClass: 'si-warning-toast si-error-popup',
                        iconClass: 'icon-ucl-warning-icon',
                        showPopup: true
                    };
                    this.handleToast(stateToSet);
                }
                if (response) {
                    if (response.findIndex((league) => { return league.TypeId == 3 && league.ShowList == 1 }) >= 0) {
                        this.getClubsList()
                    }
                }
            });
        }
    };


    getClubsList() {
        if (this.props.fetchClubs) {
            this.props.fetchClubs()
        }
    }

    handleToast = (popupState) => {
        this.setState(popupState);
    };
    onCreateLeagueTap = () => {
        // common.customTracking('Create League', '/uclfantasy/leagues/');
        // return this.props.history.push('/create-league');
        this.setState({ showCreateLeague: true })
    };
    onJoinLeagueTap = () => {
        // common.customTracking('Join League');
        common.virPathTracking('leagueJoin');
        this.setState((previousState) => {
            if (previousState.joinLeaguePopup) {
                common.removeLocalStorage('leagueInvObj');
                const { leagueCode } = this.props.match.params;
                if (leagueCode) {
                    return this.props.history.replace('/leagues');
                }
            }
            return { joinLeaguePopup: !previousState.joinLeaguePopup }
        });
    };
    showSharePopup = (e, LeagueCode, LeagueId, LeagueName, ShareLoad, isCard) => {
        e.stopPropagation();
        if(isCard){
            common.customTracking('Invite Users - Card', '/uclfantasy/leagues/');
        }
        else{
            common.customTracking('Invite Users - Card', '/uclfantasy/leagues/private/');
        }
        
        this.setState({ LeagueCode, LeagueId, LeagueName, ShareLoad, showShare: true });
    };
    onShareTap = () => {
        this.setState((previousState) => {
            return { showShare: !previousState.showShare };
        });
    };
    resetToast = () => {
        this.handleToast({ showPopup: false, message: '' });
    };

    toggleTooltip() {
        this.setState({ tooltipActive: !this.state.tooltipActive })
    }

    onCloseCreateLeague() {
        this.setState({ showCreateLeague: false });
    }

    onDecline() {
        common.removeLocalStorage('leagueInvObj');
        common.customTracking('Decline League', '/uclfantasy/leagues/');
        const { leagueCode } = this.props.match.params;
        if (leagueCode) {
            return this.props.history.replace('/leagues');
        }
        this.setState({ showInvitePopup: false })
    }

    onInviteJoinError(msg, retVal) {
        common.removeLocalStorage('leagueInvObj');
        this.setState({ showInvitePopup: false, inviteJoinError: msg })
    }

    onSubmitErrorPopup() {
        this.setState({ inviteJoinError: "" })
        const { leagueCode } = this.props.match.params;
        if (leagueCode) {
            return this.props.history.replace('/leagues');
        }
    }

    render() {
        const { trans, leagues, publicLeagues, constraints } = this.props;
        const {
            message, showPopup, popupWrapperClass, iconClass, joinLeaguePopup, isMoreOpen, isToast,
            readAbleShareLoad, showShare, LeagueCode, LeagueId, LeagueName, ShareLoad, showInvitePopup
        } = this.state;
        const dataToShare = { LeagueCode, LeagueId, LeagueName, ShareLoad, constraints };
        const popupProps = {
            showPopup,
            isToast,
            resetToast: this.resetToast,
            message,
            wrapperClass: popupWrapperClass,
            iconClass: iconClass
        };
        const overallLeague = (leagues['current'] || []);
        const prvSeasonLeague = (leagues['previous'] || []);
        forEach(prvSeasonLeague, league => league.isPreviousSeason = true);
        const currentSeasonLeaguesYouAreAdminOf = filter(overallLeague, league => +league['IsUserAdmin'] === 1);
        const previousLeaguesYouAreAdminOf = filter(prvSeasonLeague, league => +league['IsUserAdmin'] === 1);
        const currentSeasonLeaguesYouArePartOf = filter(overallLeague, league => +league['IsUserAdmin'] === 0);
        const previousLeaguesYouArePartOf = filter(prvSeasonLeague, league => +league['IsUserAdmin'] === 0);
        const showRules = false;
        const currSeasonLeagues = concat(currentSeasonLeaguesYouAreAdminOf, currentSeasonLeaguesYouArePartOf);
        const prevSeasonLeagues = concat(previousLeaguesYouAreAdminOf, previousLeaguesYouArePartOf);
        const allPrivateLeagues = concat(currSeasonLeagues, prevSeasonLeagues)

        const allLeaguesLength = allPrivateLeagues.length//leaguesYouManage.length + yourLeagues.length;
        const menuClasses = common.makeClasses({
            'si-more-btn': true,
            'si-cols': true,
            'si-active': isMoreOpen
        });
        let isEot = common.isEndOfSeason(constraints.GamercardSubScenario);
        const COOKIE_GM = config.COOKIE_GM;
        let cookie = common.getCookie(COOKIE_GM);

        return (<div className="si-main-component si-manage-team si-no-anim si-leagues">
            <div className="si-container si-diff-header">
                <div className="si-top-section">
                    <div className="si-heading-wrap si-flexBox">
                        <div className="si-title"><span>{ trans['menu_leagues'] }</span></div>
                        {
                            (allPrivateLeagues && allPrivateLeagues.length >= 1)
                                ?
                                <div className="si-btn-wrp" style={ isEot ? common.hideVisibility() : {} }>
                                    <div className="si-btn si-btn-secondary" onClick={ () => this.onCreateLeagueTap() }>
                                        <span>+ { trans['create_league_cta'] }</span>
                                    </div>
                                    <div className="si-btn si-btn-secondary" onClick={ () => this.onJoinLeagueTap() }>
                                        <span>{ trans['join_league_cta'] }</span>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className="si-overall-info si-flexBox">
                        {/* <div className="si-back-btn si-cols">
                        </div> */}
                        <div className="si-cols si-header-txt">
                            <span>{ trans['menu_leagues'] }</span>
                        </div>
                        <div className="si-plyr-score si-flexBox">
                            <span />
                            <div className="si-score-wrap">
                                <span className="si-pts" />
                                <span className="si-pts-txt" />
                            </div>
                        </div>
                        {/* <div className={ menuClasses } onClick={ () => this.toggleMoreIcon() }>
                            <i className="icon-ucl-more" />
                            { isMoreOpen ? <OutsideNotifier handler={ this.toggleMoreIcon.bind(this) }>
                                <div className="si-more-menu">
                                    { showRules ? <span
                                        onClick={ () => this.onRulesTap() }>{ this.props.trans['menu_rules'] }</span> : null } */}
                                    {/* <span onClick={ () => this.onHelpTap() }>{ this.props.trans['help_n_feedback'] }</span> */}
                                {/* </div>
                            </OutsideNotifier> : null }
                        </div> */}
                    </div>
                </div>
                <div className="si-leagues-container si-sm-container si-column-layout">
                    {
                        (allPrivateLeagues && allPrivateLeagues.length >= 1)
                            ?
                            <div className="si-league-btns">
                                <div className="si-btn si-btn-secondary" onClick={ () => this.onCreateLeagueTap() }>
                                    <span>+ { trans['create_league_cta'] }</span>
                                </div>
                                <div className="si-btn si-btn-secondary" onClick={ () => this.onJoinLeagueTap() }>
                                    <span>{ trans['join_league_cta'] }</span>
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        (allPrivateLeagues && allPrivateLeagues.length <= 0 && !isEot)
                            ?
                            <div className="si-leagues-card">
                                <div className="si-league-head">
                                    <span className="si-league-title">{ trans['your_leagues'] || "Private Leagues" }</span>
                                    {/* {
                                        (allPrivateLeagues && allPrivateLeagues.length <= 0)
                                            ?
                                            <OutsideNotifier handler={this.toggleTooltip}>
                                                <span className={"si-icon-wrap " + (this.state.tooltipActive ? "si-active" : "")} onClick={this.toggleTooltip}>
                                                    <i className="icon-ucl-info"></i>
                                                    <div className="si-tooltip">
                                                        <div className="si-tt-head">{trans['tooltipTitlePrivateLeague'] || "Play with friends"}</div>
                                                        <div className="si-tt-desc">{trans['tooltipDescPrivateLeague'] || "These are leagues that you or your friends created. New players need an invite code or link to join."}</div>
                                                    </div>
                                                </span>
                                            </OutsideNotifier>
                                            :
                                            null
                                    } */}

                                </div>
                                <div className="si-league-body">
                                    <div className="si-create-card">
                                        <div className="si-create-info">
                                            <div className="si-create-title">{ trans['createOrJoinLeague'] || "Create or join a league" }</div>
                                            <div className="si-create-desc">{ trans['playExclusively'] || "Play exclusively against your friends. Create your own private league, or join one your friend started." }</div>
                                        </div>
                                        <div className="si-btn-wrp">
                                            <div className="si-btn si-btn-primary" onClick={ () => this.onCreateLeagueTap() }>
                                                <span>+ { trans['create_league_cta'] }</span>
                                            </div>
                                            <div className="si-btn si-btn-primary" onClick={ () => this.onJoinLeagueTap() }>
                                                <span>{ trans['join_league_cta'] }</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                    {/* <LeagueHomePageCard handleToast={this.handleToast.bind(this)} leagues={leaguesYouManage}
                        length={allLeaguesLength}
                        getLeagues={this.getLeagues.bind(this)}
                        showSharePopup={this.showSharePopup.bind(this)}
                        headText={trans['leagues_you_manage']} /> */}
                    <LeagueHomePageCard handleToast={ this.handleToast.bind(this) } leagues={ currSeasonLeagues }
                        length={ currSeasonLeagues.length }
                        getLeagues={ this.getLeagues.bind(this) }
                        showSharePopup={ this.showSharePopup.bind(this) }
                        headText={ trans['private_Leagues'] || "PRIVATE LEAGUES" } />

                    <LeagueHomePageCard handleToast={ this.handleToast.bind(this) } leagues={ prevSeasonLeagues }
                        length={ prevSeasonLeagues.length }
                        getLeagues={ this.getLeagues.bind(this) }
                        showSharePopup={ this.showSharePopup.bind(this) }
                        isPrevSeasonLeagues={ true }
                        hideTitle={ currSeasonLeagues.length > 0 }
                        headText={ trans['private_Leagues'] || "PRIVATE LEAGUES" }
                    />

                    <AdBottom />

                    <LeagueHomePageCard handleToast={ this.handleToast.bind(this) } leagues={ publicLeagues }
                        length={ allLeaguesLength }
                        getLeagues={ this.getLeagues.bind(this) }
                        showSharePopup={ this.showSharePopup.bind(this) }
                        headText={ trans['public_leagues'] }
                        isPublic={ true }
                        clubs={ this.props.clubs }
                    />
                </div>
            </div>
            <GeneralPopUp { ...popupProps } />
            { showShare ? <LeagueShare { ...dataToShare } trans={ trans } toHide={ this.onShareTap.bind(this) } /> : null }
            { joinLeaguePopup ? <JoinLeague
                readAbleShareLoad={ readAbleShareLoad.leagueCode }
                toShow={ this.state.joinLeaguePopup }
                onJoinLeagueTap={ this.onJoinLeagueTap.bind(this) }
                getLeagues={ this.getLeagues.bind(this) }
                handleToast={ this.handleToast.bind(this) }
            /> : null }
            {
                showInvitePopup
                    ?
                    <LeagueInvite
                        leagueCode={ readAbleShareLoad.leagueCode }
                        leagueName={ readAbleShareLoad.leagueName }
                        userName={ readAbleShareLoad.userName }
                        onDecline={ this.onDecline }
                        onError={ this.onInviteJoinError }
                    />
                    :
                    null
            }
            {
                (this.state.inviteJoinError && this.state.inviteJoinError.length)
                    ?
                    <LeaguesErrorPopup
                        message={ this.state.inviteJoinError }
                        buttonText={ trans['gotIt'] || "Got it" }
                        onSubmit={ this.onSubmitErrorPopup }
                    />
                    :
                    null
            }
            {
                this.state.showCreateLeague
                    ?
                    <CreateLeaguePopup onClose={ this.onCloseCreateLeague } />
                    :
                    null
            }
        </div>)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLeaguesData: (GUID, pageNo) => dispatch(getLeaguesData(GUID, pageNo)),
        getPublicLeaguesData: (GUID, CountryId, FavTeamId, LangCode) => dispatch(getPublicLeaguesData(GUID, CountryId, FavTeamId, LangCode)),
        fetchClubs: () => dispatch(fetchClubs())
    };
};
const mapStateToProps = (state) => {

    return {
        trans: state.appData.trans,
        leagues: state.leaguesData.leagues,
        publicLeagues: state.leaguesData.publicLeagues,
        constraints: state.appData.constraints,
        clubs: state.formationData.clubsData.response
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(Leagues));


// WEBPACK FOOTER //
// ./src/components/leagues/index.js